import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { ArrowLeft, EnvelopeSimple } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="app-shell min-h-screen p-6 flex flex-col">
      <Link to="/login" className="btn-ghost self-start -ml-2" data-testid="back-to-login">
        <ArrowLeft size={20} weight="bold" /> Back to sign in
      </Link>
      <div className="flex items-center mt-6 mb-2" data-testid="forgot-logo">
        <img src="/fairway-logo.png" alt="Fairway" className="h-16 w-auto rounded-2xl" />
      </div>
      <h1 className="font-heading font-black tracking-tighter-2 text-4xl sm:text-5xl text-[var(--primary)] mt-6 mb-2">
        Forgot password
      </h1>
      <p className="text-[var(--text-secondary)] mb-8">
        Pop your email in below and we&apos;ll send you a link to set a new password.
      </p>

      {done ? (
        <div
          className="surface-card p-6 text-center"
          data-testid="forgot-password-success"
        >
          <div
            className="w-14 h-14 mx-auto mb-3 rounded-full flex items-center justify-center"
            style={{ background: "var(--accent-sand)", color: "var(--primary)" }}
          >
            <EnvelopeSimple size={28} weight="bold" />
          </div>
          <h2 className="font-heading font-bold text-xl text-[var(--primary)] mb-2">Check your inbox</h2>
          <p className="text-sm text-[var(--text-secondary)] mb-4">
            If <strong>{email}</strong> is registered, you&apos;ll get a reset link in the next minute.
            The link expires in 1 hour.
          </p>
          <Link to="/login" className="btn-primary inline-flex w-full" data-testid="return-to-login">
            Back to sign in
          </Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-testid="forgot-password-form">
          <div>
            <label className="label-uppercase block mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
              className="input-field"
              placeholder="you@example.com"
              data-testid="forgot-email-input"
            />
          </div>
          {error && (
            <div
              data-testid="forgot-error"
              className="text-sm text-[var(--status-bad)] bg-red-50 border border-red-200 rounded-xl px-4 py-3"
            >
              {error}
            </div>
          )}
          <button
            type="submit"
            className="btn-primary mt-2"
            disabled={submitting || !email}
            data-testid="forgot-submit-button"
          >
            {submitting ? "Sending..." : "Email me a reset link"}
          </button>
        </form>
      )}
    </div>
  );
}
